import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header text-nowrap" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_4 = { class: "lh-1" }
const _hoisted_5 = { class: "card-body overflow-hidden d-flex justify-content-between flex-column text-center" }
const _hoisted_6 = { class: "fs-1 mb-2" }
const _hoisted_7 = { class: "fs-1 mb-2" }
const _hoisted_8 = {
  key: 1,
  class: "row h-100"
}
const _hoisted_9 = { class: "col-6 fs-6 border-end d-flex justify-content-between flex-column" }
const _hoisted_10 = { class: "position-relative mb-1" }
const _hoisted_11 = { class: "position-absolute top-50 start-50 mt-1 ps-1" }
const _hoisted_12 = { class: "small text-muted text-nowrap" }
const _hoisted_13 = { class: "small ms-1" }
const _hoisted_14 = { class: "small overflow-hidden" }
const _hoisted_15 = { class: "small" }
const _hoisted_16 = { class: "col-6 fs-6 d-flex justify-content-between flex-column" }
const _hoisted_17 = { class: "position-relative mb-1" }
const _hoisted_18 = { class: "position-absolute top-50 start-50 mt-1 ps-1" }
const _hoisted_19 = { class: "small text-muted text-nowrap" }
const _hoisted_20 = { class: "small ms-1" }
const _hoisted_21 = { class: "small overflow-hidden" }
const _hoisted_22 = { class: "small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("h6", { class: "mb-0 text-truncate" }, [
          _createElementVNode("i", { class: "fas fa-share-alt fa-fw fa-rotate-90 me-2" }),
          _createTextVNode("Bono de Red Binaria ")
        ], -1)),
        _createElementVNode("span", _hoisted_4, [
          _createElementVNode("span", {
            class: _normalizeClass(["fw-bold small mx-1", 
              !_ctx.accountSummary.hasBinaryNetworkBonus
                ? 'opacity-50 text-decoration-line-through'
                : ''
            ])
          }, _toDisplayString(_ctx.accountSummary.binaryPercentage) + "%", 3),
          _createElementVNode("i", {
            class: _normalizeClass(
              'align-middle ' +
              _ctx.binaryBonusIconClass(
                _ctx.accountSummary?.innerLegUnlocked ?? false,
                _ctx.accountSummary?.hasBinaryNetworkBonus,
                _ctx.accountSummary?.bonusRemainingDays
              )
            )
          }, null, 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (!_ctx.accountSummary?.innerLegUnlocked)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("i", {
                class: _normalizeClass(
              'fa-lg ' +
              _ctx.binaryBonusIconClass(
                _ctx.accountSummary?.innerLegUnlocked ?? false,
                _ctx.accountSummary?.hasBinaryNetworkBonus,
                _ctx.accountSummary?.bonusRemainingDays
              )
            )
              }, null, 2)
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("div", null, [
              _createElementVNode("div", { class: "small d-flex flex-column overflow-hidden" }, [
                _createElementVNode("span", { class: "text-nowrap fw-bold" }, " Bono Binario Bloqueado "),
                _createElementVNode("span", { class: "small" }, "Para poder desbloquearlo debes calificar tu beca")
              ])
            ], -1))
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.isBinaryBonusExpired)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("i", {
                      class: _normalizeClass(
                'fa-lg ' +
                _ctx.binaryBonusIconClass(
                  _ctx.accountSummary?.innerLegUnlocked ?? false,
                  _ctx.accountSummary?.hasBinaryNetworkBonus,
                  _ctx.accountSummary?.bonusRemainingDays
                )
              )
                    }, null, 2)
                  ]),
                  _cache[2] || (_cache[2] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "small d-flex flex-column overflow-hidden" }, [
                      _createElementVNode("span", { class: "text-nowrap fw-bold" }, " Bono Binario Inactivo "),
                      _createElementVNode("span", { class: "small" }, "Para activarlo debes tener un socio activo de cada lado")
                    ])
                  ], -1))
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "small fw-bold mb-1" }, "Izquierdo", -1)),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["fs-3 fa-stack", 
                    'text-' +
                    _ctx.binaryBonusDaysColorClass(_ctx.binaryExpiration?.left.daysLeft)
                  ])
                      }, [
                        _cache[3] || (_cache[3] = _createElementVNode("i", { class: "far fa-circle fa-stack-2x" }, null, -1)),
                        _createElementVNode("i", {
                          class: _normalizeClass(["fas fa-stack-1x", 
                      _ctx.binaryBonusSideIconClass(_ctx.binaryExpiration?.left.daysLeft)
                    ])
                        }, null, 2)
                      ], 2),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge rounded-pill", 
                        'bg-' +
                        _ctx.binaryBonusDaysColorClass(
                          _ctx.binaryExpiration?.left.daysLeft
                        )
                      ])
                          }, _toDisplayString(_ctx.binaryExpiration?.left.daysLeft), 3),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.durationUnitLocalized(
                        _ctx.binaryExpiration?.left.daysLeft || 0,
                        "days"
                      )), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.formatDateTimezone(
                    _ctx.binaryExpiration?.left.endDate?.valueOf() || 0
                  )), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "small fw-bold mb-1" }, "Derecho", -1)),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["fs-3 fa-stack", 
                    'text-' +
                    _ctx.binaryBonusDaysColorClass(_ctx.binaryExpiration?.right.daysLeft)
                  ])
                      }, [
                        _cache[5] || (_cache[5] = _createElementVNode("i", { class: "far fa-circle fa-stack-2x" }, null, -1)),
                        _createElementVNode("i", {
                          class: _normalizeClass(["fas fa-stack-1x", 
                      _ctx.binaryBonusSideIconClass(_ctx.binaryExpiration?.right.daysLeft)
                    ])
                        }, null, 2)
                      ], 2),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge rounded-pill", 
                        'bg-' +
                        _ctx.binaryBonusDaysColorClass(
                          _ctx.binaryExpiration?.right.daysLeft
                        )
                      ])
                          }, _toDisplayString(_ctx.binaryExpiration?.right.daysLeft), 3),
                          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.durationUnitLocalized(
                        _ctx.binaryExpiration?.right.daysLeft || 0,
                        "days"
                      )), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.formatDateTimezone(
                    _ctx.binaryExpiration?.right.endDate?.valueOf() || 0
                  )), 1)
                    ])
                  ])
                ]))
          ], 64))
    ])
  ]))
}